module.exports = __webpack_public_path__ + "0425ece0dafa19e61f2e8ac130ead863.MP3";